import Vue from 'vue'
import axios from 'axios'
import _ from 'underscore'
import util from '@/index/libs/util.js'
import { Message } from 'element-ui'
import adapter from './adapter.js'
import router from '@/index/router'
import $ from 'jQuery'
// console.log('plugin/axios/index.js')
function setContentTypeIfUnset (headers, value) {
  if (headers !== undefined && headers['Content-Type'] !== undefined) {
    headers['Content-Type'] = value
  }
}
if (window.location.href.indexOf('index.pub.html') > -1) {
  axios.defaults.baseURL = 'https://tea.api.mding.org'
} else if (window.location.href.indexOf('doc.mding.org') > -1 ||
  window.location.href.indexOf('localhost') > -1 ||
  window.location.href.indexOf('127.0.0.1') > -1 ||
  window.location.href.indexOf('192.168.') > -1 ||
  window.location.href.indexOf('file://') > -1) {
  // axios.defaults.baseURL = 'https://dev.mding.org'
  axios.defaults.baseURL = 'https://tea.api.mding.org'
} else {
  axios.defaults.baseURL = 'https://tea.api.mding.org'
}
// 1.204就链接1.204
if (window.location.href.indexOf('192.168.1.204') > -1) {
  axios.defaults.baseURL = 'http://192.168.1.204:8083'
}

// 如果是我的本地就链接松松
if (window.location.href.indexOf('192.168.16.') > -1) {
  axios.defaults.baseURL = 'http://192.168.16.51:8083'
  // axios.defaults.baseURL = 'http://192.168.1.204:8083'
}

axios.defaults.timeout = 8000
axios.interceptors.response.use(res => {
  return res.data
}, err => {
  let d = err.response
  // console.log('err', err)
  // console.log('response', d)
  if (d && d.data && d.data.code !== 200) {
    if (_.has(d.data, 'code')) {
      // console.log('d.data.message', d.data.message)
      if (_.has(d.data, 'message')) {
        Message.error(d.data.message)
      } else {
        Message.error('系统报错')
      }
      if (d.data.code === 401) {
        // console.log('Vue', Vue)
        // console.log('vue.prototype', Vue.prototype)
        router.push({ name: 'login' })
      }
    }
  }
  return Promise.reject(err)
})
axios.interceptors.request.use((config) => {
  let token = util.cookies.get('token')
  if (config.method === 'post') {
    config.data = config.data || {}
    _.extend(config.data, { token: token })
  } else {
    if (config.url.indexOf('http://') === -1 && config.url.indexOf('https://') === -1) {
      config.params = config.params || {}
      _.extend(config.params, { token: token })
    }
  }
  return config
})
axios.defaults.transformRequest = [function (data, headers) {
  if (data) {
    let v = $.param(data)
    return v
  } else {
    return ''
  }
}]
axios.defaults.transformResponse = [function (data) {
  // console.log('transformResponse.data', data)
  data = JSON.parse(data)
  if (data.code !== 200) {
    return data
  } else {
    return data.data
  }
}]
axios.defaults.validateStatus = function (d) {
  // console.log('status', d)
  return d === 200
}
axios.defaults.adapter = adapter
axios.downloadFile = function (url, data, options) {
  let config = $.extend(true, { method: 'post' }, options)
  let $iframe = $('<iframe id="down-file-iframe" />')
  let $form = $('<form target="down-file-iframe" method="' + config.method + '" />')
  $form.attr('action', url)
  _.extend(data, {
    token: util.cookies.get('token')
  })
  for (var key in config.data) {
    $form.append('<input type="hidden" name="' + key + '" value="' + data[key] + '" />')
  }
  $iframe.append($form)
  $(document.body).append($iframe)
  $form[0].submit()
  $iframe.remove()
}
Vue.prototype.$axios = axios
